import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as SearchIcon } from "../assets/btn-send.svg";
import { useRecoEngineBlock } from "../hooks";

const RecoEngineBlock = () => {
  const [t] = useTranslation("translations");
  const { handleRecommendation, updateQuery } = useRecoEngineBlock();
  const [inputValue, setInputValue] = useState("");
  
  useEffect(() => {
    updateQuery("");
    setInputValue("")
  }, []); 

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateQuery(e.target.value);
    setInputValue(e.target.value);
  };

  const handleSubmit = () => {
    if (!inputValue.trim()) return;

    handleRecommendation(inputValue);

    setInputValue("");
  };

  return (
    <div className="reco_engine__search-Container">
      <div className="input-wrapper">
        <input
          className={`reco-search-input ${!inputValue ? "inactive" : ""}`}
          onChange={handleInputChange}
          placeholder={t("RecoSearch.placeholder_text")}
          maxLength={300}
          value={inputValue}
          aria-label="Search"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleSubmit();
            }
          }}
        />
        <button
          className="recoEngine__send"
          type="submit"
          onClick={() => handleSubmit()}
          disabled={!inputValue.trim()}
        >
          <SearchIcon className="search-icon" />
        </button>
      </div>
    </div>
  );
}

export default RecoEngineBlock;
